module.exports = __webpack_public_path__ + "static/media/doctorIcon.7398259b.png";